import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Cookie from "js-cookie";
import { useDispatch } from "react-redux";

import * as Constants from "../../../../constants/Constants";
import { formatDate } from "../../../../utils/DateUtility";
import {
    httpPostSaveVendorStatusByProfileId,
    httpGetVendorStatusDetails
} from "../../../../service/httpClient";
import { updateServiceData } from "../../../../redux/serviceSlice";
import { updateCommonInfo } from "../../../../redux/commonSlice";

const EINVerification = ({
    merchandiseType,
    vendorConnectionPlatform,
    history,
    vendorProfileId,
    vendorDetails: { taxEin, taxName, taxContactEmail },
    vendorStatus,
    extractVendorStatus,
}) => {
    const dispatch = useDispatch();

    const [einData, setEINData] = useState({
        taxEin: "",
        taxName: "",
        taxContactEmail: "",
        einVerification: false,
        approvedBy: "",
        approvalDate: ""
    });
    const [isApproved, setIsApproved] = useState(false);
    const [einStatusData, setEinStatusData] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [btnDisabled, setBtnDisabled] = useState(false);

    useEffect(() => {
        if (merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE || 
            !Constants.STATUS_PLATFORMTYPE_MIRAKL.includes(vendorConnectionPlatform)
        ) {
            history.push("/boarding/vendor/company");
            return;
        }
    }, [
        merchandiseType, 
        vendorConnectionPlatform
    ]);

    useEffect(() => {
        let einVerificationStatus = null;

        if (vendorStatus && vendorStatus.length > 0) {
            einVerificationStatus = vendorStatus.find(status => {
                return (
                    status.vendorStatus && 
                    status.vendorStatus.statusId === 31
                );
            });
        }

        let einVerification = einVerificationStatus?.vendorStatus?.lastStatusUpdatedValue === Constants.APPROVED;
        const data = {
            ...einData,
            taxEin, 
            taxName, 
            taxContactEmail,
            einVerification,
            approvedBy: einVerification ? (einVerificationStatus?.updatedByFullName || '') : '',
            approvalDate: (einVerification && einVerificationStatus && 
                einVerificationStatus.vendorStatus && 
                einVerificationStatus.vendorStatus.lastStatusUpdatedDate) ? 
            formatDate(einVerificationStatus?.vendorStatus?.lastStatusUpdatedDate) : '',
        };     
        setEINData(data);
        setIsApproved(einVerification);
        setEinStatusData(einVerificationStatus || null);
    }, [
        taxEin, 
        taxName, 
        taxContactEmail,
        vendorStatus
    ]);

    const handleChange = (e) => {
        const { name } = e.target;
        if (name === "einVerification") {
            const data = {
                ...einData,
                einVerification: !einData.einVerification
            };     
            setEINData(data);
        }
    }

    const handleApprove = () => {
        if (einStatusData && einData.einVerification) {
            setBtnDisabled(true);
            const userEmail = Cookie.get("email") ? Cookie.get("email").toLowerCase() : "";
            const payload = {
                ...einStatusData,
                vendorStatus: {
                    ...einStatusData.vendorStatus,
                    lastStatusUpdatedValue: Constants.APPROVED,
                    lastStatusUpdatedBy: userEmail,
                },
                userEmail,
                updatedByFullName: Cookie.get("userName") ? Cookie.get("userName") : "",
            };

            httpPostSaveVendorStatusByProfileId(payload)
            .then(res => {
                if (res && res.status === 200) {
                    return httpGetVendorStatusDetails(vendorProfileId);
                } else {
                    throw new Error("Something went wrong, try after sometime.");
                }
            })
            .then(res => {
                const { mutatedVendorStatus } = extractVendorStatus(
                    Constants.APPROVED,
                    res.data
                );
        
                //update vendorStatus in service data
                dispatch(
                    updateServiceData({
                        vendorStatus: res.data,
                    })
                );
                //update vendorstatus in common slice
                dispatch(
                    updateCommonInfo({
                        boardingStatuses: mutatedVendorStatus,
                    })
                );
                setErrorMessage("");
                setBtnDisabled(false);
                setSuccessMessage("EIN Verification is complete.")
            })
            .catch(error => {
                console.log(error);
                if (error.response && error.response.status === 400) {
                    setErrorMessage(error.response?.data?.message);
                } else {
                    setErrorMessage(error.message);
                }
                setBtnDisabled(false);
                setSuccessMessage("");
            });
        }
    }

    return (
        <Row className="ein-verification-container">
            <Col>
                {errorMessage && (
                    <Row className="py-0">
                        <Col className="px-3">
                            <p className="actionErrorMsg">
                                {errorMessage}
                            </p>
                        </Col>
                    </Row>
                )}

                {successMessage && (
                    <Row className="py-0">
                        <Col className="px-3">
                            <p className="einError validationSuccessMsg">
                                {successMessage}
                            </p>
                        </Col>
                    </Row>
                )}
                <Row className="pt-0">
                    <Col lg={6}>
                        <Form autoComplete="none">
                            <Form.Group>
                                <Form.Label
                                    htmlFor="taxEin"
                                >
                                    EIN
                                </Form.Label>
                                <Form.Control
                                    id="taxEin"
                                    name="taxEin"
                                    placeholder="EIN"
                                    value={einData.taxEin}
                                    onChange={(e) => {}}
                                    disabled        
                                    style={{
                                        width: "max-content"
                                    }}                            
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label
                                    htmlFor="taxName"
                                >
                                    Tax Name
                                </Form.Label>
                                <Form.Control
                                    id="taxName"
                                    name="taxName"
                                    placeholder="Tax Name"
                                    value={einData.taxName}
                                    onChange={(e) => {}}
                                    disabled
                                    style={{
                                        overflow: scroll
                                    }}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label
                                    htmlFor="taxContactEmail"
                                >
                                    Tax Email Address
                                </Form.Label>
                                <Form.Control
                                    id="taxContactEmail"
                                    name="taxContactEmail"
                                    placeholder="Tax Email Address"
                                    value={einData.taxContactEmail}
                                    onChange={(e) => {}}
                                    disabled
                                    style={{
                                        overflow: scroll
                                    }}
                                />
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col lg={6}>
                        <Form.Group className="mb-0">
                            <div className="d-flex">
                                <p
                                    className="mr-4"
                                >
                                    EIN Verification: 
                                </p>
                                <Form.Check
                                    id="einVerification"
                                    name="einVerification"
                                    type="checkbox"
                                    onChange={handleChange}
                                    checked={einData.einVerification}
                                    disabled={isApproved}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <p>
                                Approver: <strong>{einData.approvedBy || ''}</strong>
                            </p>
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <p>
                                Date: <strong>{einData.approvalDate || ''}</strong>
                            </p>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button
                            disabled={!einData.einVerification || isApproved || btnDisabled}
                            className="button-primary-md button-primary-auto"
                            onClick={handleApprove}
                        >
                            {Constants.BUTTON_APPROVE}
                        </Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
};

export default EINVerification;
